import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TextBodyExpandedIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "TextBodyExpanded",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M5 23.29h3.43v3.43H5z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M8.43 27.86H5c-.63 0-1.14-.51-1.14-1.14v-3.43c0-.63.51-1.14 1.14-1.14h3.43c.63 0 1.14.51 1.14 1.14v3.43c0 .63-.51 1.14-1.14 1.14m-2.29-2.29h1.14v-1.14H6.14zM23.29 23.29h3.43v3.43h-3.43z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M26.71 27.86h-3.43c-.63 0-1.14-.51-1.14-1.14v-3.43c0-.63.51-1.14 1.14-1.14h3.43c.63 0 1.14.51 1.14 1.14v3.43c0 .63-.51 1.14-1.14 1.14m-2.28-2.29h1.14v-1.14h-1.14zM14.14 23.29h3.43v3.43h-3.43z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M17.57 27.86h-3.43c-.63 0-1.14-.51-1.14-1.14v-3.43c0-.63.51-1.14 1.14-1.14h3.43c.63 0 1.14.51 1.14 1.14v3.43c0 .63-.51 1.14-1.14 1.14m-2.28-2.29h1.14v-1.14h-1.14zM14.14 14.14h3.43v3.43h-3.43z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M17.57 18.71h-3.43c-.63 0-1.14-.51-1.14-1.14v-3.43c0-.63.51-1.14 1.14-1.14h3.43c.63 0 1.14.51 1.14 1.14v3.43c0 .63-.51 1.14-1.14 1.14m-2.28-2.28h1.14v-1.14h-1.14zM23.29 14.14h3.43v3.43h-3.43z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M26.71 18.71h-3.43c-.63 0-1.14-.51-1.14-1.14v-3.43c0-.63.51-1.14 1.14-1.14h3.43c.63 0 1.14.51 1.14 1.14v3.43c0 .63-.51 1.14-1.14 1.14m-2.28-2.28h1.14v-1.14h-1.14zM23.29 5h3.43v3.43h-3.43z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M26.71 9.57h-3.43c-.63 0-1.14-.51-1.14-1.14V5c0-.63.51-1.14 1.14-1.14h3.43c.63 0 1.14.51 1.14 1.14v3.43c0 .63-.51 1.14-1.14 1.14m-2.28-2.28h1.14V6.15h-1.14z"
    })]
  }));
};